export class CreateAssetTempStore {
    private static rootKey = 'create_asset_temp'

    constructor() {
        this.initRootIfNeed()
    }

    private initRootIfNeed() {
        const root = this.getRoot()
        if (root == null) {
            console.log("No root for temp store")
            this.initRoot()
        }
    }

    initRoot() {
        const rootData = {
            items: {}
        }
        localStorage.setItem(CreateAssetTempStore.rootKey, JSON.stringify(rootData))
    }

    getRoot(): any {
        const root = localStorage.getItem(CreateAssetTempStore.rootKey)
        return root != null ? JSON.parse(root) : null
    }

    private saveRoot(root: any) {
        localStorage.setItem(CreateAssetTempStore.rootKey, JSON.stringify(root))
    }

    remove(id: string) {
        //console.log("Will remove data for id:%s", id)
        const root = this.getRoot()
        //console.log("Current state:%s", JSON.stringify(root))
        delete root.items[id]
        this.saveRoot(root)
        //console.log("After state:%s", JSON.stringify(root))
    }
    add(id: string, data: any) {
        //console.log("Will add data:%s for id:%s", JSON.stringify(data), id)
        const root = this.getRoot()
        //console.log("Current state:%s", JSON.stringify(root))
        root.items[id] = data
        this.saveRoot(root)
        //console.log("After state:%s", JSON.stringify(root))
    }
}